export class EmailServerConfig {
  host: string = "";
  port: number = 0;
  secure: boolean = false;
  user: string = "";
  password: string = "";
  tls: boolean = false;
  auth: { user: string; pass: string; } = { user: "", pass: ""};
}
